import {Theme} from '@mui/material/styles';

export default function Tab(theme: Theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          flexDirection: 'row',
          fontSize: '16px',
          '&:not(.Mui-selected)': {
            color: theme.palette.text.secondary,
          },
          '&.Mui-selected': {
            color: theme.palette.text.primary,
          },
          textTransform: 'none',
          fontWeight: 'bold',
          '@media (min-width: 600px)': {
            minWidth: 'initial',
          },
        },
        labelIcon: {
          minHeight: 'initial',
        },
        textColorInherit: {
          opacity: 1,
        },
      },
    },
  };
}
